import React from 'react';

import './index.css';
import dots from '../../img/work-dots.svg';
import dotsRight from '../../img/dots-hero-right.svg';


export default ({ title, subtitle, body, image }) => {
  return (
    <section className="strategy-hero">
      <span className="circle" />
      <img
        className="center-dots"
        src={dots}
        alt="Dots"
      />
      <img
        className="left-dots"
        src={dots}
        alt="Dots"
      />
      <img
        className="right-dots"
        src={dotsRight}
        alt="Dots"
      />
      <div className="top root-padding">
        <div className="left">
          <h1 className="c-title">{title}</h1>
          <p className="subtitle">{subtitle}</p>
        </div>
        <img
          className="right"
          src={require(`../../img/${image}`).default}
          alt="Hero"
        />
      </div>
      <div className="bottom secondary-padding">
        <p>{body}</p>
      </div>
    </section>
  );
};
